export default function ToggleIconComponent(props) {
    const { activeIcon, inactiveIcon, isActive, ...rest } = props
    const Icon = props.isActive ? props.activeIcon : props.inactiveIcon
    return <Icon {...rest} />
}